/** Angezeigte UI-Version — aus `client/package.json` via Vite `define` injiziert. */
export const APP_DISPLAY_VERSION = String(import.meta.env.VITE_APP_VERSION || "dev");
